import { alerts } from "keys"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { actions } from "store"

const useAlert2 = () => {
    const dispatch = useDispatch()

    const handleCreateClassAlert = useCallback((val, props) => {
        dispatch(actions.setAlerts({
            key: alerts.createClass2,
            value: { open: val, props: props || null }
        }))
    }, [])

    return handleCreateClassAlert
}

export default useAlert2